import { useStipendWalletsQuery, StipendStatus } from "@common/utils/graphql";
import { useMemo } from "react";

export enum EmployeeStipendsSelectedTab {
  Active = "Active",
  Inactive = "Inactive",
  Upcoming = "Upcoming",
}

export const tabs = [
  {
    id: EmployeeStipendsSelectedTab.Active,
    name: EmployeeStipendsSelectedTab.Active.toString(),
    route: "/stipends/active",
  },
  {
    id: EmployeeStipendsSelectedTab.Inactive,
    name: EmployeeStipendsSelectedTab.Inactive.toString(),
    route: "/stipends/inactive",
  },
  {
    id: EmployeeStipendsSelectedTab.Upcoming,
    name: EmployeeStipendsSelectedTab.Upcoming.toString(),
    route: "/stipends/upcoming",
  },
];

export const useStipendWallets = (selectedTab: EmployeeStipendsSelectedTab) => {
  const filter = {
    [EmployeeStipendsSelectedTab.Active]: [StipendStatus.Active],
    [EmployeeStipendsSelectedTab.Inactive]: [
      StipendStatus.Expired,
      StipendStatus.Disabled,
    ],
    [EmployeeStipendsSelectedTab.Upcoming]: [StipendStatus.Upcoming],
  }[selectedTab];

  const { data, loading, networkStatus, error, refetch } =
    useStipendWalletsQuery({
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "cache-and-network",
      variables: {
        filters: {
          expirationStatus: filter,
        },
      },
    });

  const maybeData =
    data?.stipendWallets.__typename === "QueryStipendWalletsSuccess"
      ? data.stipendWallets.data
      : undefined;

  const walletsByFrequency = useMemo(
    () => maybeData?.wallets || [],
    [maybeData],
  );

  return {
    data: walletsByFrequency,
    loading,
    error,
    refetch,
    networkStatus,
  };
};
